import { buildUri } from "../../utils/dom";

export class AppointmentCategoriesService {

    #hierarchyData;

    get uri() {
        return buildUri(v24Scheduler.serviceRegion, `/api/scheduler/AppointmentCategories`);
    }

    get categories() {
        return this.#hierarchyData.categories;
    }

    async loadCategories({ sitename, locationId }) {

        if (!sitename) {
            throw new Error("sitename is not defined");
        }

        this.#hierarchyData = await this.#loadCategories({ sitename, locationId });
    }

    async #loadCategories({ sitename, locationId }){

        let data =  await this.#getCategories({ sitename, locationId });

        if((locationId) && (data.categories.length === 0)) {
            data = await this.#getCategories({ sitename });
            console.warn(`No category data exists by location ${locationId}, returning all categories.`);
        }

        return data;
    }

    async #getCategories({ sitename, locationId }){

        const params = new URLSearchParams();

        params.append("sitename", sitename);

        if (locationId) {
            params.append("locationId", locationId);
        }

        const uri = `${this.uri}?${params.toString()}`;

        return await fetch(uri).then(response => response.json());
    }
}